module.exports = __webpack_public_path__ + "img/file-earmark-binary.187b46c7.svg";